import React from 'react';
import AnswerSheets from './AnswerSheets';

export default function BookletDraftSheets({ settings, ...props }) {
    // A booklet draft is always anonymous, including nominal booklet downloads.
    return <AnswerSheets {...props} user={null} blankCandidate settings={{ ...settings, habilitada: false, rascunho: true }} />;
}
